import { render, staticRenderFns } from "./ReturnedUniform.vue?vue&type=template&id=189366ed&scoped=true"
import script from "./ReturnedUniform.vue?vue&type=script&lang=js"
export * from "./ReturnedUniform.vue?vue&type=script&lang=js"
import style0 from "./ReturnedUniform.vue?vue&type=style&index=0&id=189366ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189366ed",
  null
  
)

export default component.exports